import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "../configs/AppConfig";

const DashboardService = {};

DashboardService.getDashboardSummary = function () {
  return fetch({
    url: API_BASE_URL + "/v1/admin/dashboard/summary",
    method: "get",
    // headers: {
    //   "Cache-Control": "no-cache",
    //   Pragma: "no-cache",
    // },
  });
};

DashboardService.getActionItems = function ({ read = false }) {
  return fetch({
    url: API_BASE_URL + `/v1/admin/dashboard/action-items?read=${read}`,
    method: "get",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });
};

DashboardService.dismissActionItem = (id) => {
  return fetch({
    url: API_BASE_URL + `/v1/admin/dashboard/action-item/${id}/dismiss`,
    method: "patch",
  });
};

export default DashboardService;
